import { z } from 'zod'
import { optionalText, requiredId, requiredText } from '../../../lib/forms/rules'
import { COLUMN_BYTES } from '../../../lib/columnBytes'

/**
 * Toplantı grubu formu (038): kayıt grubu zorunlu (122), ad zorunlu (≤250), açıklama opsiyonel (≤4000).
 *
 * **Ad sınırı 1000'den 250'ye çekildi (2026-09-15).** 1000 hiçbir zaman gerçek değildi:
 * `MEETING_GROUP.NAME` kolonu `VARCHAR2(250)`'dir, yani 250'den uzun bir ad **saf ASCII'de bile**
 * sunucuda `ORA-12899` ile düşüyordu — form 1000 karakter yazdırıyor ama kaydettirmiyordu. Gerekçenin
 * tamamı `MeetingGroupUpsertDto.name` javadoc'unda.
 */
export const meetingGroupFormSchema = z.object({
  groupId: requiredId(),
  name: requiredText(250, COLUMN_BYTES.meetingGroupName),
  description: optionalText(4000, COLUMN_BYTES.meetingGroupDescription),
})

export type MeetingGroupFormValues = z.infer<typeof meetingGroupFormSchema>
